export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const PAGE_PER_VIEW = 10;
export const apiKey = 'b8370433-50a0-4e8f-8872-7cec587f93bc';
export const MODAL_CLOSE_SEC = 2.5;
